import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import {
  getAccount,
  getAccountError,
  getAccountRegistrationType,
  getChallenge,
  getChangeEmailToken,
  getLoginAttemptResult,
  getReferer,
  getRefererError,
  getReferralCode,
  getReturnUrl,
  getSetPasswordError,
  getSetPasswordMessage,
  getSetPasswordToken,
  getTrackingObject,
  getUnusualLoginError,
  getUnusualLoginMessage,
  getUserAccount,
  getUserEmail,
  isAccountLoggingIn,
  isAccountRegistered,
  isAccountRegistering,
  isRefererLoaded,
  isRefererLoading,
  isSetPasswordProcessing,
} from '../reducers';
import {
  Account,
  Challenge,
  LoginAttemptResult,
  Referer,
  UserAccount,
} from '../models';
import {
  GrantTypeEnum,
  IAccountResponseError,
  IChangeEmailToken,
  ISetPasswordToken,
} from '../../account.data';
import { ITrackingObject } from 'i2g-ng-tracking';

@Injectable()
export class AccountStore {
  constructor(private _store: Store<any>) {}

  getTrackingObject(): Observable<ITrackingObject> {
    return this._store.pipe(select(getTrackingObject));
  }

  isAccountRegistering(): Observable<boolean> {
    return this._store.pipe(select(isAccountRegistering));
  }

  isAccountRegistered(): Observable<boolean> {
    return this._store.pipe(select(isAccountRegistered));
  }

  getAccount(): Observable<Account> {
    return this._store.pipe(select(getAccount));
  }

  getUserAccount(): Observable<UserAccount> {
    return this._store.pipe(select(getUserAccount));
  }

  getUserEmail(): Observable<string> {
    return this._store.pipe(select(getUserEmail));
  }

  getAccountError(): Observable<Error | IAccountResponseError> {
    return this._store.pipe(select(getAccountError));
  }

  getAccountRegistrationType(): Observable<GrantTypeEnum> {
    return this._store.pipe(select(getAccountRegistrationType));
  }

  isRefererLoading(): Observable<boolean> {
    return this._store.pipe(select(isRefererLoading));
  }

  isRefererLoaded(): Observable<boolean> {
    return this._store.pipe(select(isRefererLoaded));
  }

  getReferralCode(): Observable<string> {
    return this._store.pipe(select(getReferralCode));
  }

  getReferer(): Observable<Referer> {
    return this._store.pipe(select(getReferer));
  }

  getRefererError(): Observable<any> {
    return this._store.pipe(select(getRefererError));
  }

  getReturnUrl(): Observable<string> {
    return this._store.pipe(select(getReturnUrl));
  }

  isAccountLoggingIn(): Observable<boolean> {
    return this._store.pipe(select(isAccountLoggingIn));
  }

  getSetPasswordMessage(): Observable<string> {
    return this._store.pipe(select(getSetPasswordMessage));
  }

  getSetPasswordError(): Observable<Error | IAccountResponseError> {
    return this._store.pipe(select(getSetPasswordError));
  }

  isSetPasswordProcessing(): Observable<boolean> {
    return this._store.pipe(select(isSetPasswordProcessing));
  }

  getSetPasswordToken(): Observable<ISetPasswordToken> {
    return this._store.pipe(select(getSetPasswordToken));
  }

  getChangeEmailToken(): Observable<IChangeEmailToken> {
    return this._store.pipe(select(getChangeEmailToken));
  }

  getChallenge(): Observable<Challenge> {
    return this._store.pipe(select(getChallenge));
  }

  getUnusualLoginMessage(): Observable<string> {
    return this._store.pipe(select(getUnusualLoginMessage));
  }

  getUnusualLoginError(): Observable<IAccountResponseError> {
    return this._store.pipe(select(getUnusualLoginError));
  }

  getLoginAttemptResult(): Observable<LoginAttemptResult> {
    return this._store.pipe(select(getLoginAttemptResult));
  }
}
